import React, { useState, useEffect, useContext, useMemo } from "react";

import * as Yup from "yup";
import {
    Formik,
    Form
    // FieldArray // ✅ REMOVIDO: No se usa
} from "formik";
import { toast } from "react-toastify";

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    // Grid, // ✅ REMOVIDO: No se usa
    makeStyles,
    useTheme,
    TextField,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    IconButton,
    Paper,
    Tooltip
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
// import AttachFileIcon from "@material-ui/icons/AttachFile"; // ✅ REMOVIDO: No se usa
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import ImageIcon from "@material-ui/icons/Image";

import { green } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import CampaignMessageComposer from "../CampaignMessageComposer";
import AttachmentPreview from "../AttachmentPreview";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        gap: 4
    },
    multFieldLine: {
        display: "flex",
        "& > *:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },
    // ✅ CORREGIDO: TextField dinámico según tema
    textField: {
        marginRight: theme.spacing(1),
        flex: 1,
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
            color: theme.palette.text.primary,
            boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
            '&:hover': {
                boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.15)',
            },
            '&.Mui-focused': {
                boxShadow: `0 4px 12px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.4)' : 'rgba(25, 118, 210, 0.3)'}`,
            },
            "& fieldset": {
                borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: theme.palette.primary.main,
        },
        "& .MuiFormHelperText-root": {
            color: theme.palette.text.secondary || theme.palette.text.primary,
        },
    },
    extraAttr: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    btnWrapper: {
        position: "relative",
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 2000,
    },
    colorAdorment: {
        width: 20,
        height: 20,
    },
    // ✅ NUEVOS ESTILOS PARA DRAG & DROP Y TABLA
    // ✅ CORREGIDO: DragDropZone dinámico según tema
    dragDropZone: {
        border: `2px dashed ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        textAlign: "center",
        backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.primary.light + "10",
        marginBottom: theme.spacing(1),
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
        "&:hover": {
            backgroundColor: theme.mode === 'dark' ? '#4B5563' : theme.palette.primary.light + "20",
            borderColor: theme.palette.primary.dark,
            transform: "translateY(-1px)",
            boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.12)',
        },
        "&.dragActive": {
            backgroundColor: theme.mode === 'dark' ? '#4B5563' : theme.palette.primary.light + "30",
            borderColor: theme.palette.primary.dark,
            transform: "scale(1.01)",
            boxShadow: `0 6px 16px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.4)' : 'rgba(25, 118, 210, 0.3)'}`,
        },
    },
    dragDropIcon: {
        fontSize: 32,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
    },
    dragDropText: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
    },
    dragDropSubtext: {
        color: theme.palette.text.disabled,
        fontSize: "0.875rem",
    },
    fileIcon: {
        width: 32,
        height: 32,
        backgroundColor: theme.palette.grey[100],
    },
    fileIconPdf: {
        backgroundColor: "#f44336",
        color: "white",
    },
    fileIconDoc: {
        backgroundColor: "#2196f3",
        color: "white",
    },
    fileIconImage: {
        backgroundColor: "#4caf50",
        color: "white",
    },
    fileIconVideo: {
        backgroundColor: "#ff9800",
        color: "white",
    },
    fileIconAudio: {
        backgroundColor: "#9c27b0",
        color: "white",
    },
    fileIconDefault: {
        backgroundColor: theme.palette.grey[400],
        color: "white",
    },
    formatChip: {
        fontSize: "0.75rem",
        height: 20,
    },
    sizeText: {
        color: theme.palette.text.secondary,
        fontSize: "0.75rem",
    },
    // ✅ CABECERA AZUL DEL SISTEMA
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        fontSize: '0.875rem',
    },
    tableHeaderCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        fontSize: '0.8rem',
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
        padding: '12px 8px',
    },
    // ✅ CORREGIDO: FilesTable dinámico según tema
    filesTable: {
        marginTop: theme.spacing(1),
        borderRadius: theme.spacing(1),
        overflow: "hidden",
        boxShadow: theme.mode === 'dark' ? "0 2px 8px rgba(0,0,0,0.3)" : "0 2px 8px rgba(0,0,0,0.08)",
        backgroundColor: theme.palette.background.paper,
    },
    // ✅ CORREGIDO: TableRow dinámico según tema
    tableRow: {
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
            transform: 'translateY(-1px)',
            boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
            transition: 'all 0.2s ease-in-out',
        },
        transition: 'all 0.2s ease-in-out',
        '& td': {
            color: theme.palette.text.primary,
            borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e0e0e0'}`,
        },
    },
    actionButton: {
        margin: '0 4px',
        padding: '8px',
        borderRadius: '50%',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
    },
    deleteButton: {
        backgroundColor: '#f44336',
        color: 'white',
        '&:hover': {
            backgroundColor: '#d32f2f',
        },
    },
}));

const initialState = {
    name: "",
    message: "",
    options: [],
};

const FilesModal = ({ open, onClose, fileListId, reload }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { user } = useContext(AuthContext);
    const [selectedFileNames, setSelectedFileNames] = useState([]);
    const [dragActive, setDragActive] = useState(false);

    const fileListSchema = useMemo(
        () =>
            Yup.object().shape({
                name: Yup.string()
                    .min(3, i18n.t("fileModal.validation.nameMin"))
                    .required(i18n.t("fileModal.validation.required")),
                message: Yup.string()
                    .required(i18n.t("fileModal.validation.required"))
            }),
        [i18n.language],
    );
    
    // ✅ Variables no utilizadas removidas para evitar warnings

    // ✅ FUNCIONES DE UTILIDAD PARA ARCHIVOS
    const getFileIcon = (fileName, file = null) => {
        const extension = fileName.split('.').pop().toLowerCase();
        
        // ✅ MOSTRAR MINIATURA REAL PARA IMÁGENES
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
            if (file && file.file) {
                // ✅ IMAGEN LOCAL - mostrar preview
                return (
                    <img 
                        src={URL.createObjectURL(file.file)}
                        alt={fileName}
                        style={{
                            width: 40,
                            height: 40,
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                            boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    />
                );
            } else if (file && file.path && fileListId) {
                // ✅ IMAGEN SUBIDA - mostrar desde servidor
                const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
                return (
                    <img 
                        src={`${backendUrl}/public/fileList/${fileListId}/${file.path}`}
                        alt={fileName}
                        style={{
                            width: 40,
                            height: 40,
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                            boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                        onError={(e) => {
                            // ✅ FALLBACK: Si falla la carga, mostrar icono genérico
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                );
            } else {
                // ✅ FALLBACK: Mostrar icono genérico para imágenes
                return <ImageIcon className={`${classes.fileIcon} ${classes.fileIconImage}`} />;
            }
        }
        
        // ✅ ICONOS PARA OTROS TIPOS DE ARCHIVO
        if (['pdf'].includes(extension)) {
            return <PictureAsPdfIcon className={`${classes.fileIcon} ${classes.fileIconPdf}`} />;
        } else if (['doc', 'docx'].includes(extension)) {
            return <DescriptionIcon className={`${classes.fileIcon} ${classes.fileIconDoc}`} />;
        } else if (['mp4', 'avi', 'mov', 'wmv', 'flv'].includes(extension)) {
            return <VideoLibraryIcon className={`${classes.fileIcon} ${classes.fileIconVideo}`} />;
        } else if (['mp3', 'wav', 'flac', 'aac'].includes(extension)) {
            return <MusicNoteIcon className={`${classes.fileIcon} ${classes.fileIconAudio}`} />;
        } else {
            return <InsertDriveFileIcon className={`${classes.fileIcon} ${classes.fileIconDefault}`} />;
        }
    };

    const getFileFormat = (fileName) => {
        return fileName.split('.').pop().toUpperCase();
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return `0 ${i18n.t("fileModal.fileSize.bytes")}`;
        const k = 1024;
        const sizes = [
            i18n.t("fileModal.fileSize.bytes"),
            i18n.t("fileModal.fileSize.kb"),
            i18n.t("fileModal.fileSize.mb"),
            i18n.t("fileModal.fileSize.gb"),
        ];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    // ✅ FUNCIONES DE DRAG & DROP
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragActive(true);
        }
    };

    const handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
    };

    const handleDrop = (e, setFieldValue, values) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files, setFieldValue, values);
        }
    };

    const handleFiles = (fileList, setFieldValue, values) => {
        const newFiles = Array.from(fileList).map(file => ({
            name: file.name,
            file: file,
            mediaType: file.type,
            size: file.size,
            path: file.name,
            id: `temp_${Date.now()}_${Math.random()}` // ✅ ID TEMPORAL ÚNICO
        }));

        // ✅ ACTUALIZAR SOLO EL ESTADO DE FORMIK
        const updatedOptions = [...(values.options || []), ...newFiles];
        setFieldValue('options', updatedOptions);
        
        // ✅ Archivos agregados exitosamente

        setSelectedFileNames(prev => [...prev, ...Array.from(fileList).map(f => f.name)]);
    };

    // ✅ USEEFFECT PARA CARGAR DATOS CUANDO SE EDITA UNA LISTA EXISTENTE
    const [loadedData, setLoadedData] = useState(null);
    
    useEffect(() => {
        if (fileListId && open && !loadedData) {
            (async () => {
                try {
                    const { data } = await api.get(`/files/${fileListId}`);
                    // ✅ Datos cargados para edición
                    setLoadedData(data);
                    setSelectedFileNames(data.options?.map(opt => opt.name || opt.path) || []);
                } catch (err) {
                    toastError(err);
                }
            })();
        }
    }, [fileListId, open, loadedData]);

    // ✅ RESETEAR loadedData CUANDO SE CIERRA EL MODAL
    useEffect(() => {
        if (!open) {
            setLoadedData(null);
        }
    }, [open]);

    // ✅ REMOVER EL USEEFFECT DUPLICADO

    const handleClose = () => {
        // ✅ NO LIMPIAR EL ESTADO DEL FORMULARIO AQUÍ
        // La limpieza se maneja automáticamente por Formik
        setSelectedFileNames([]);
        setDragActive(false);
        onClose();
    };

    const handleSaveFileList = async (values) => {
        const uploadFiles = async (filesOptions, id) => {
            const formData = new FormData();
            formData.append("fileId", id);
            formData.append("typeArch", "fileList")
            filesOptions.forEach((fileOption) => {
                if (fileOption.file) {
                    formData.append("files", fileOption.file);
                    formData.append("mediaType", fileOption.file.type)
                    formData.append("name", fileOption.name);
                }
            });

            try {
                const { data } = await api.post(`/files/uploadList/${id}`, formData);
                return data;
            } catch (err) {
                toastError(err);
                throw err;
            }
        }

        // ✅ FILTRAR ARCHIVOS TEMPORALES PARA ENVIAR AL BACKEND
        const filesToSave = values.options.filter(option => !option.id || !String(option.id).startsWith('temp_'));
        const newFilesToUpload = values.options.filter(option => option.id && String(option.id).startsWith('temp_'));
        
        // ✅ CREAR LISTA SIN ARCHIVOS NUEVOS (solo con archivos existentes)
        const fileData = { 
            ...values, 
            userId: user.id,
            options: filesToSave // ✅ Solo archivos ya guardados
        };
        
        try {
            let currentFileListId = fileListId;
            if (currentFileListId) {
                // ✅ EDITAR LISTA EXISTENTE
                await api.put(`/files/${currentFileListId}`, fileData);
            } else {
                // ✅ CREAR NUEVA LISTA
                const { data } = await api.post("/files", fileData);
                currentFileListId = data.id;
            }
            
            // ✅ SUBIR ARCHIVOS NUEVOS DESPUÉS DE CREAR/ACTUALIZAR LA LISTA
            if (newFilesToUpload.length > 0) {
                await uploadFiles(newFilesToUpload, currentFileListId);
            }
            
            toast.success(i18n.t("fileModal.success"));
            if (typeof reload == 'function') {
                reload();
            }
            // ✅ NO LIMPIAR FORMULARIO - solo cerrar modal
            onClose();
        } catch (err) {
            toastError(err);
        }
    };

    return (
        <div className={classes.root}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth={false}
                scroll="paper"
                PaperProps={{
                    style: {
                        width: '900px',
                        maxWidth: '95vw',
                        borderRadius: '12px',
                        boxShadow: theme.mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.5)' : '0 8px 32px rgba(0,0,0,0.12)',
                        backgroundColor: theme.palette.background.paper,
                    }
                }}>
                <DialogTitle id="form-dialog-title" style={{ backgroundColor: theme.palette.primary.main, color: 'white' }}>
                    {(fileListId ? `${i18n.t("fileModal.title.edit")}` : `${i18n.t("fileModal.title.add")}`)}
                </DialogTitle>
                <Formik
                    initialValues={loadedData || initialState}
                    enableReinitialize={true}
                    validationSchema={fileListSchema}
                    onSubmit={async (values, actions) => {
                        try {
                            await handleSaveFileList(values);
                        } finally {
                            actions.setSubmitting(false);
                        }
                    }}
                >
                    {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <DialogContent dividers style={{ padding: '16px 24px', backgroundColor: theme.palette.background.paper }}>
                                {/* ✅ CAMPOS BÁSICOS */}
                                <div className={classes.multFieldLine}>
                                    <TextField
                                        label={i18n.t("fileModal.form.name")}
                                        name="name"
                                        value={values.name || ""}
                                        onChange={(e) => setFieldValue('name', e.target.value)}
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        className={classes.textField}
                                    />
                                </div>
                                <div className={classes.multFieldLine} style={{ marginTop: '16px' }}>
                                    <CampaignMessageComposer
                                        label={i18n.t("fileModal.form.message")}
                                        value={values.message || ""}
                                        onChange={(next) => setFieldValue('message', next)}
                                        error={touched.message && Boolean(errors.message)}
                                        helperText={touched.message && errors.message}
                                        placeholder={i18n.t("fileModal.form.message")}
                                        rows={4}
                                        maxLength={2000}
                                        showCounter
                                    />
                                </div>

                                {/* ✅ DRAG & DROP ZONE */}
                                <Typography
                                    style={{ marginBottom: 8, marginTop: 16, color: theme.palette.text.primary }}
                                    variant="subtitle1"
                                >
                                    {i18n.t("fileModal.dragDrop.sectionTitle")}
                                </Typography>

                                <Box
                                    className={`${classes.dragDropZone} ${dragActive ? 'dragActive' : ''}`}
                                    onDragEnter={handleDragIn}
                                    onDragLeave={handleDragOut}
                                    onDragOver={handleDrag}
                                    onDrop={(e) => handleDrop(e, setFieldValue, values)}
                                    onClick={() => document.getElementById('file-input-modal').click()}
                                >
                                    <CloudUploadIcon className={classes.dragDropIcon} />
                                    <Typography variant="body1" className={classes.dragDropText}>
                                        {i18n.t("fileModal.dragDrop.main")}
                                    </Typography>
                                    <Typography variant="body2" className={classes.dragDropSubtext}>
                                        {i18n.t("fileModal.dragDrop.sub")}
                                    </Typography>
                                    <Typography variant="caption" className={classes.dragDropSubtext}>
                                        {i18n.t("fileModal.dragDrop.formats")}
                                    </Typography>
                                    <input
                                        id="file-input-modal"
                                        type="file"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFiles(e.target.files, setFieldValue, values)}
                                    />
                                </Box>

                                {/* ✅ TABLA DE ARCHIVOS CON 6 COLUMNAS */}
                                {values.options && values.options.length > 0 && (
                                    <Paper className={classes.filesTable}>
                                        <Table size="small" style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <TableHead>
                                                <TableRow className={classes.tableHeader}>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.thumbnail")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '300px', minWidth: '300px' }}>{i18n.t("fileModal.table.name")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.format")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '120px' }}>{i18n.t("fileModal.table.size")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.type")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} align="center" style={{ width: '100px' }}>{i18n.t("fileModal.table.actions")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {values.options.map((file, index) => (
                                                <TableRow key={index} className={classes.tableRow}>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            <AttachmentPreview
                                                                file={file.file || null}
                                                                mediaPath={file.path}
                                                                mediaName={file.name || file.path}
                                                                mediaType={file.mediaType}
                                                                fileListId={fileListId}
                                                                size="compact"
                                                                showInfo={false}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ width: '300px', minWidth: '300px', overflow: 'hidden' }}>
                                                            <Tooltip 
                                                                title={file.name || file.path}
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <Typography 
                                                                    variant="body2" 
                                                                    noWrap
                                    style={{ 
                                        cursor: 'pointer', 
                                        color: theme.palette.primary.main,
                                        textDecoration: 'underline',
                                        maxWidth: '280px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                                                    onClick={() => {
                                                                        // ✅ CONSTRUIR URL CORRECTA DEL ARCHIVO
                                                                        const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
                                                                        let fileUrl;
                                                                        
                                                                        if (file.path && fileListId) {
                                                                            // ✅ ARCHIVO YA SUBIDO - usar ruta del servidor
                                                                            fileUrl = `${backendUrl}/public/fileList/${fileListId}/${file.path}`;
                                                                        } else if (file.file) {
                                                                            // ✅ ARCHIVO LOCAL - crear URL temporal
                                                                            fileUrl = URL.createObjectURL(file.file);
                                                                        }
                                                                        
                                                                        if (fileUrl) {
                                                                            window.open(fileUrl, '_blank');
                                                                        } else {
                                                                            console.warn('No se pudo determinar la URL del archivo:', file);
                                                                        }
                                                                    }}
                                                                >
                                                                    {file.name || file.path}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            <Chip 
                                                                label={getFileFormat(file.name || file.path)} 
                                                                size="small"
                                                                className={classes.formatChip}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ width: '120px', overflow: 'hidden' }}>
                                                            <Typography className={classes.sizeText}>
                                                                {file.size ? formatFileSize(file.size) : 
                                                                 file.file?.size ? formatFileSize(file.file.size) : 
                                                                 'N/A'}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            <Tooltip 
                                                                title={file.mediaType || 'N/A'}
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <Typography 
                                                                    className={classes.sizeText}
                                                                    style={{
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        maxWidth: '90px'
                                                                    }}
                                                                >
                                                                    {file.mediaType || 'N/A'}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ width: '100px', overflow: 'hidden' }}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={async () => {
                                                                    try {
                                                                        // ✅ Eliminando archivo
                                                                        
                                                                        // ✅ ELIMINAR ARCHIVO INDIVIDUAL DEL BACKEND SI TIENE ID REAL
                                                                        if (file.id && fileListId && !String(file.id).startsWith('temp_')) {
                                                                            await api.delete(`/files/${fileListId}/options/${file.id}`);
                                                                            // ✅ Archivo eliminado del servidor
                                                                        } else {
                                                                            // ✅ Archivo temporal, solo eliminando del frontend
                                                                        }
                                                                        
                                                                        // ✅ ELIMINAR DEL FRONTEND DE FORMA MÁS ROBUSTA
                                                                        const newOptions = values.options.filter((_, i) => i !== index);
                                                                        setFieldValue('options', newOptions);
                                                                        
                                                                        const newFileNames = selectedFileNames.filter((_, i) => i !== index);
                                                                        setSelectedFileNames(newFileNames);
                                                                        
                                                                        // ✅ NO NECESITAMOS ACTUALIZAR ESTADO LOCAL
                                                                        // Formik ya maneja el estado
                                                                        
                                                                        // ✅ Archivo eliminado de la interfaz
                                                                    } catch (error) {
                                                                        console.error(`❌ Error eliminando archivo ${file.name}:`, error);
                                                                        toast.error(`Error eliminando archivo: ${error.message}`);
                                                                    }
                                                                }}
                                                                title={i18n.t("fileModal.tooltips.removeFile")}
                                                                style={{
                                                                    backgroundColor: '#f44336',
                                                                    color: 'white',
                                                                    margin: '0 4px',
                                                                    padding: '8px',
                                                                    borderRadius: '50%',
                                                                    minWidth: '32px',
                                                                    minHeight: '32px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#d32f2f';
                                                                    e.target.style.transform = 'scale(1.1)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#f44336';
                                                                    e.target.style.transform = 'scale(1)';
                                                                }}
                                                            >
                                                                <DeleteOutlineIcon style={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                )}
                            </DialogContent>
                            <DialogActions style={{ backgroundColor: theme.palette.background.paper, borderTop: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e0e0e0'}` }}>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    disabled={isSubmitting}
                                    variant="outlined"
                                >
                                    {i18n.t("fileModal.buttons.cancel")}
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={isSubmitting}
                                    variant="contained"
                                    className={classes.btnWrapper}
                                >
                                    {fileListId
                                        ? `${i18n.t("fileModal.buttons.okEdit")}`
                                        : `${i18n.t("fileModal.buttons.okAdd")}`}
                                    {isSubmitting && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </div>
    );
};

export default FilesModal;
